import { Message, Thread } from '../message-service/message.model';
import { Borrower } from 'app/models/dto/borrower.model';

export class SendMessage {
static readonly type = '[Message] Send';
constructor(public message: Message) {}
}

export class SendNewMessage {
static readonly type = '[Message] SendNewMessage';
constructor(public message: Message) {}
}

export class SendThreadReply {
static readonly type = '[Message] SendThreadReply';
constructor(public id: number, public message: Message) {}
}

export class ThreadReply {
static readonly type = '[Message] Thread Reply';
constructor(public id: number, public message: Message) {}
}

export class AddBorrowerToMessage {
static readonly type = '[Message] AddBorrowerToMessage';
constructor(public id: number, public borrower: Borrower, public threadId: number) {}
}

export class GetMessageVariables {
static readonly type = '[Message] GetMessageVariables';
constructor(public borrowerId: number) {}
}

export class GetEmailSignature {
static readonly type = '[Message] GetEmailSignature';
constructor(public borrowerId: number) {}
}

export class MessageAlertDismissed {
  static readonly type = '[Message] MessageAlertDismissed';
  constructor() {}
}

export class GetMessageThreadHistory {
  static readonly type = '[Message] GetMessageThreadHistory';
  constructor(
    public borrowerId: number,
    public refresh?: boolean
  ) {}
}

export class GetUnknownThreads {
  static readonly type = '[Thread] GetUnknownThreads';
  constructor(public lenderUserId: number) {}
}
export class DeleteMessageFromUnknownSender {
  static readonly type = '[Thread] DeleteMessageFromUnknownSender';
  constructor(public messageId: number, public threadId: number) {}
}

export class GetMessageThreadFullHistory {
  static readonly type = '[Message] GetMessageThreadFullHistory';
  constructor(public borrowerId: number) {}
}

export class SubscribeToBorrowerMessages {
  static readonly type = '[Message] SubscribeToBorrowerMessages';
  constructor(public borrowerId: number) {}
}

export class SubscribeToBorrowerEmails {
  static readonly type = '[Message] SubscribeToBorrowerEmails';
  constructor(public borrowerId: number) {}
}

export class ClearThreadStore {
  static readonly type = '[Message] ClearThreadStore';
  constructor(public borrowerId: number) {}
}

export class MessageRead {
  static readonly type = '[Message] MessageRead';
  constructor(public message: Message) {}
}

export class MarkThreadRead {
  static readonly type = '[Message] MarkThreadRead';
  constructor(
    public threadId: number,
  ) {}
}

export class MarkBorrowerThreadRead {
  static readonly type = '[Message] MarkBorrowerThreadRead';
  constructor(
    public threadId: number,
  ) {}
}

export class PatchIndividualThread {
  static readonly type = '[Message] PatchIndividualThread';
  constructor(public thread: Thread) {}
}

export class GetInboxEmailList {
  static readonly type = '[Message] GetInboxEmailList';
  constructor(public borrower: Borrower, public loadMore: boolean, public sort: boolean) {}
}

export class GetMarketingEmailList {
  static readonly type = '[Message] GetMarketingEmailList';
  constructor(public borrowerId: number, public loadMore: boolean, public sort: boolean) {}
}

export class GetAllEmailList {
  static readonly type = '[Message] GetAllEmailList';
  constructor(public borrowerId: number, public loadMore: boolean, public sort: boolean) {}
}

export class RefreshInboxEmailList {
  static readonly type = '[Message] RefreshInboxEmailList';
  constructor(public borrowerId: number) {}
}

export class RefreshAllEmailList {
  static readonly type = '[Message] RefreshAllEmailList';
  constructor(public borrowerId: number) {}
}

export class GetActiveEmailThread {
  static readonly type = '[Message] GetActiveEmailThread';
  constructor(public threadId: number, public silentLoad: boolean) {}
}

export class ClearEmailsStore {
  static readonly type = '[Message] ClearEmailsStore';
  constructor(public borrowerId: number) {}
}

export class GetLendioEmailDirectory {
  static readonly type = '[Message] GetLendioEmailDirectory';
  constructor() {}
}
